/** @format */

import React, { useEffect } from "react";
import useSettings from "stores/settings";
import { PageTokenCheck } from "function/PageTokenCheck";
import { useRouter } from "next/router";

const Payment = () => {
  const settings = useSettings();
  const router = useRouter();
  /* 로그인 체크 : url 이동 */
  useEffect(() => {
    PageTokenCheck(settings, router);
  }, []);

  return (
    <div className="border-table">
      <div className="checkout">
        <div className="credit-card-box">
          <div className="flip">
            <div className="front">
              <div className="chip"></div>
              <div className="logo pt-4">
                <img src="/images/visa-icon.png" alt="" />
              </div>
              {/* FIXME:등록된 카드 번호가 나타납니다 */}
              <div className="number">1234 1234 1234 1234</div>

              <div className="card-holder">
                <label>VALID THRU</label>
                {/* FIXME:등록된 이름이 나타납니다 */}
                <div>SHIN YEJIN</div>
              </div>
              <div className="card-expiration-date">
                <label>MONTH / YEAR</label>
                {/* FIXME:카드 유효기간이 나타납니다 */}
                <div>08/23</div>
              </div>
            </div>
            <div className="back">
              <div className="strip"></div>
              <div className="logo sm:pt-4">
                <img src="/images/visa-icon.png" alt="" />
              </div>
              <div className="ccv">
                <label>CCV</label>
                {/* FIXME:CCV가 나타납니다 */}
                <div>888</div>
              </div>
            </div>
          </div>
        </div>
        <form className="form" autoComplete="off" noValidate>
          <fieldset>
            <label htmlFor="card-number">Card Number</label>
            <input type="num" id="card-number" className="input-cart-number" maxLength="4" />
            <input type="num" id="card-number-1" className="input-cart-number" maxLength="4" />
            <input type="num" id="card-number-2" className="input-cart-number" maxLength="4" />
            <input type="num" id="card-number-3" className="input-cart-number" maxLength="4" />
          </fieldset>
          <button className="btn btn-primary w-full">등록</button>
        </form>
      </div>
    </div>
  );
};

export default Payment;
